import { useTranslation } from 'react-i18next';
import { Button } from '@/components/ui/button';
import { useStudioStore } from '@/store/useStudioStore';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import { Globe } from 'lucide-react';

/** 语言切换按钮组件 */
export const LanguageToggle = () => {
  const { i18n, t } = useTranslation();
  const { isBuilding } = useStudioStore();

  const changeLanguage = (lang: string) => {
    i18n.changeLanguage(lang);
  };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          variant="outline"
          disabled={isBuilding ?? false}
          size="icon"
          className="h-10 w-10 rounded-full border border-gray-200 bg-white shadow-md transition-all hover:bg-gray-50 focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 focus:outline-none disabled:opacity-50"
        >
          <Globe className="h-[1.2rem] w-[1.2rem] text-gray-700" />
          <span className="sr-only">{t('common:language_toggle.toggle')}</span>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-32 rounded-xl p-1 shadow-lg">
        <DropdownMenuItem
          onClick={() => changeLanguage('zh')}
          className={`cursor-pointer rounded-lg px-3 py-2 text-sm transition-colors ${
            i18n.language === 'zh'
              ? 'bg-indigo-50 font-bold text-indigo-700'
              : 'text-gray-700 hover:bg-gray-100 hover:text-gray-900'
          }`}
        >
          🇨🇳 简体中文
        </DropdownMenuItem>
        <DropdownMenuItem
          onClick={() => changeLanguage('en')}
          className={`cursor-pointer rounded-lg px-3 py-2 text-sm transition-colors ${
            i18n.language === 'en'
              ? 'bg-indigo-50 font-bold text-indigo-700'
              : 'text-gray-700 hover:bg-gray-100 hover:text-gray-900'
          }`}
        >
          🇺🇸 English
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
